<template>
  <div>
    <div v-if="type%2===0">
      <div v-for="x in (maxX - minX)+1" :key="'x-'+x" style="display: flex">
        <div
          v-for="y in (maxY - minY)+1"
          :key="'y-'+y"
          class="csv-block color"
          :style="handleStyle(x,y)"
          @click="csvDetail(x,y)"
        />
      </div>
    </div>
    <div v-else>
      <!--   xy互换   -->
      <div v-for="x in (maxY - minY)+1" :key="'x-'+x" style="display: flex">
        <div
          v-for="y in (maxX - minX)+1"
          :key="'y-'+y"
          class="csv-block color"
          :style="handleStyle(x,y)"
          @click="csvDetail(x,y)"
        />
      </div>
    </div>
    <CsvDetail
      ref="csvDetail"
      :visible.sync="innerVisible"
    />
  </div>
</template>

<script>
import CsvDetail from './csv-detail'
export default {
  name: 'CsvImage',
  components: {
    CsvDetail
  },
  props: {
    pointList: {
      type: Object,
      default: Object
    },
    maxX: {
      type: Number,
      default: 0
    },
    minX: {
      type: Number,
      default: 0
    },
    maxY: {
      type: Number,
      default: 0
    },
    minY: {
      type: Number,
      default: 0
    },
    // 0:不旋转,1:顺时针90,2:180,3:逆时针90
    type: {
      type: Number,
      default: 0
    },
    mirrorX: {
      type: Boolean,
      default: false
    },
    mirrorY: {
      type: Boolean,
      default: false
    },
    colorType: {
      type: Array,
      default: function() {
        return [{ scope: [1], color: '#5DA569' }]
      }
    }
  },
  data() {
    return {
      innerVisible: false,
      activeX: undefined,
      activeY: undefined
    }
  },
  methods: {
    handleStyle(x, y) {
      const style = {}
      if (this.activeX === x && this.activeY === y) {
        this.$set(style, 'border', '1px solid #ff8400')
        this.$set(style, 'width', '3px')
        this.$set(style, 'height', '3px')
      }
      const toOriginal = this.convertToOriginal(x, y)
      const tmpX = toOriginal[0]
      const tmpY = toOriginal[1]
      const bin = this.pointList[tmpX * 1000 + tmpY]
      if (!bin) {
        return style
      }
      for (let i = 0; i < this.colorType.length; i++) {
        const v = this.colorType[i]
        if (v.scope.includes(parseInt(bin))) {
          this.$set(style, 'background-color', v.color)
          return style
        }
      }
      this.$set(style, 'background-color', '#492121')
      return style
    },
    init() {
      console.log(this.pointList)
    },
    csvDetail(x, y) {
      this.innerVisible = true
      this.activeX = x
      this.activeY = y
      this.$nextTick(() => {
        const toOriginal = this.convertToOriginal(x, y)
        const tmpX = toOriginal[0]
        const tmpY = toOriginal[1]
        this.$refs.csvDetail.init(tmpX, tmpY)
      })
    },
    convertToOriginal(x, y) {
      let tmpX
      let tmpY
      if (this.mirrorY) {
        if (this.type % 2 === 0) {
          y = this.maxY - this.minY - (y - 1)
        } else {
          y = this.maxX - this.minX - (y - 1)
        }
      } else {
        y--
      }
      if (this.mirrorX) {
        if (this.type % 2 === 0) {
          x = this.maxX - this.minX - (x - 1)
        } else {
          x = this.maxY - this.minY - (x - 1)
        }
      } else {
        x--
      }
      switch (this.type) {
        case 1:
          // 顺时针90
          tmpX = this.maxX - y
          tmpY = x + this.minY
          break
        case 2:
          // 180
          tmpX = this.maxX - x
          tmpY = this.maxY - y
          break
        case 3:
          // 逆时针90
          tmpX = y + this.minX
          tmpY = this.maxY - x
          break
        default:
          // 不变
          tmpX = x + this.minX
          tmpY = y + this.minY
          break
      }
      return [tmpX, tmpY]
    }
  }
}
</script>

<style scoped lang="scss">
.csv-block {
  background-color: #FFFFFF;
  width: 5px;
  height: 5px;
}

.csv-block:hover {
  border: 1px solid red;
  width: 3px;
  height: 3px;
}
.active-csv-block {
  border: 1px solid #ff8400;
  width: 3px;
  height: 3px;
}

.green {
  background-color: #5DA569;
}

.red {
  background-color: #492121;
}
</style>
